import * as XLSX from "xlsx";

export interface ExportSheet {
  sheetName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>[];
}

/**
 * Exports one or more data sets as separate sheets in a single .xlsx file.
 * @param sheets  Array of { sheetName, data } objects
 * @param fileName Optional file name (without extension). Defaults to KnowVest_Export_YYYY-MM-DD
 */
export function exportToExcel(sheets: ExportSheet[], fileName?: string): void {
  if (!sheets || sheets.length === 0) return;

  const workbook = XLSX.utils.book_new();

  sheets.forEach(({ sheetName, data }) => {
    if (!data || data.length === 0) {
      // Still add an empty sheet so the tab is visible
      const ws = XLSX.utils.aoa_to_sheet([["No data available"]]);
      XLSX.utils.book_append_sheet(workbook, ws, sheetName);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Auto-size columns based on header / content widths
    const colWidths = Object.keys(data[0]).map((key) => {
      const maxLen = Math.max(
        key.length,
        ...data.map((row) => String(row[key] ?? "").length)
      );
      return { wch: Math.min(maxLen + 2, 50) };
    });
    worksheet["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  const date = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const outputFileName = fileName ? `${fileName}.xlsx` : `KnowVest_Export_${date}.xlsx`;

  XLSX.writeFile(workbook, outputFileName);
}
